import ComponentModal from "./componentModal"

export default ComponentModal
